/**
 * Created by root on 7/2/19.
 */
/**
 * Created by root on 7/1/19.
 */
import React from "react";
import ReactDOM from "react-dom";

import { hot } from "react-hot-loader/root";
import { withTranslation } from "react-i18next";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];
/** *
 * Returns weeks range for the given month and year
 * @param month
 * @param year
 * @returns {Array}
 */

const _daylightSavingAdjust = function(date) {
  if (!date) {
    return null;
  }
  date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
  return date;
};

const _getDaysInMonth = function(year, month) {
  return 32 - _daylightSavingAdjust(new Date(year, month, 32)).getDate();
};

const getWeeksInMonth = function(month, year) {
  const weeks = [];
  const firstDate = new Date(year, month, 1);
  const lastDate = new Date(year, month + 1, 0);

  const numDays = _getDaysInMonth(year, month);

  let start = 1;
  let end = 7 - firstDate.getDay();
  // end = start === 1 && end === 8 ? 1 : end;
  while (start <= numDays) {
    // weeks.push({start:start,end:end});
    weeks.push({
      id: `${start}:${end}`,
      value: `${months[month]} ${start}-${end}`
    }); // +", " + year
    start = end + 1;
    end += 7;
    if (end > numDays) end = numDays;
  }
  return weeks;
};

class ResponseRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cellData: this.props.row
    };
    this._viewGoalDetails = this._viewGoalDetails.bind(this);
  }

  _viewGoalDetails(id) {
    if (typeof id === "undefined" || id === null || id == -1) {
      return;
    }
    const params = {};
    params.id = id;
    return viewGoalDetailsPage(undefined, params);
  }

  render() {
    // let goalId = this.state.cellData.oId;
    return (
      <div className="displayRow">
        {this.state.cellData &&
          this.state.cellData.map((d, i) => (
            <div
              key={i}
              className={`displayCell response-table-cell data-cell ${d.data.color}${d.data.link}`}
              onClick={() => this._viewGoalDetails(d.id)}
            >
              {d.value}
            </div>
          ))}
      </div>
    );
  }
}

class ResponseTable extends React.Component {
  constructor(props) {
    super(props);
    const aR = this.props.successRows.concat(this.props.notSuccessRows);

    const mappedTableData = [];
    for (const row of aR) {
      const rowData = [];
      row.goal.color = " ";
      rowData.push({ value: row.goal.input, data: row.goal, id: row.goal.id });
      for (const kr of row.krs) {
        kr.link = " ";
        rowData.push({ value: kr.value, data: kr, id: null });
      }

      // now put the last row
      row.goal.link = "clickable link";
      rowData.push({ value: row.goal.name, data: row.goal, id: row.goal.id });
      mappedTableData.push(rowData);
    }
    this.state = {
      successRows: this.props.successRows,
      notSuccessRows: this.props.notSuccessRows,
      headerMapping: this.props.mapping,
      fileName: this.props.fileName,
      period: this.props.period,
      allRows: mappedTableData,
      fileURL: this.props.fileURL
    };
    this.backAction = this.backAction.bind(this);
    this._sortThisColumn = this._sortThisColumn.bind(this);
    this.backAction = this.backAction.bind(this);
  }

  backAction() {
    loadDataMgmt();
  }

  _sortThisColumn(index) {
    const _this = this;
    // console.log("Sorting rows "+index);
    const r = _this.state.allRows;

    r.sort((r1, r2) => {
      let valueA = r1[index].value;
      let valueB = r2[index].value;

      if (isNaN(valueA)) {
        valueA = valueA.toString();
        valueB = valueB.toString();
        sortVal = valueA.localeCompare(valueB);
      } else {
        var sortVal = 0;
        if (valueA > valueB) {
          sortVal = 1;
        }
        if (valueA < valueB) {
          sortVal = -1;
        }
        /* if (sortVal !== 0) {
                 sortVal = sortVal * -1;
                 } */
      }

      return sortVal;
    });

    // console.log("Sorted data %o", r);
    setTimeout(
      () =>
        _this.setState({
          allRows: r.slice(0)
        }),
      10
    );
  }

  render() {
    // let successRows = this.state.successRows;
    // let notSuccessRows = this.state.notSuccessRows;

    return (
      <div className="response-container">
        <div className="result-top">
          <div className="displayRow">
            <div className="displayCell top-left">
              <div className="result-row bold">Import result-</div>
            </div>
            <div className="displayCell top-right">
              <div
                className="back-btn gbl-btn gb-btn-slim"
                onClick={() => this.backAction()}
              >
                back
              </div>
            </div>
          </div>
          <div className="result-row">
            File imported:
            <b>{this.state.fileName}</b>
          </div>
          <div className="result-row">
            Time frame for updates:
            <b>{this.state.period}</b>
          </div>
          <div className="result-row">
            Total Rows Processed:
            <b>
              {this.state.successRows.length + this.state.notSuccessRows.length}
            </b>
          </div>
          <div className="result-row">
            Objectives found:
            <b>{this.state.successRows.length}</b>
          </div>
          <div className="result-row">
            Objectives not found:
            <b>{this.state.notSuccessRows.length}</b>
          </div>
          <div className="result-row">
            Export import result in an excel:
            <b>
              <a className="link" href={this.state.fileURL} target="_blank">
                {" "}
                download{" "}
              </a>
            </b>
          </div>
        </div>
        <div className="displayRow response-table-header">
          {this.state.headerMapping &&
            this.state.headerMapping.map((cell, i) => (
              <div
                key={i}
                className="displayCell response-table-header-cell clickable"
                onClick={() => this._sortThisColumn(i)}
              >
                {cell}
              </div>
            ))}
          <div
            className="displayCell response-table-header-cell clickable"
            onClick={() =>
              this._sortThisColumn(this.state.headerMapping.length)
            }
          >
            Mapped Objective
          </div>
        </div>
        {this.state.allRows &&
          this.state.allRows.map((row, i) => (
            <ResponseRow key={i} row={row} index={i} />
          ))}
      </div>
    );
  }
}

class ImportContainer extends React.Component {
  constructor(props) {
    super(props);
    const date = new Date();
    const initCurrentMonth = date.getMonth();
    const initCurrentYear = date.getFullYear();

    const defaultObjective = []; // {objective: 0}
    defaultObjective.push({ objective: 0 });
    const defaultMonth = [{ month: initCurrentMonth }];
    const defaultYear = [{ year: initCurrentYear }];
    this.state = {
      excelData: [],
      optForOKRs: false,
      importYear: defaultYear,
      importMonth: defaultMonth,
      importWeek: [],
      resultMapping: [],
      resetKRMapping: new Map(),
      objectives: defaultObjective,
      fileName: false,
      errorObjective: false,
      importCheckList: true,
      errorObjectiveValue:
        "Please select a column that maps to your objective.",
      errorKR: false,
      errorInvalidFile: false,
      errorInvalidFileValue:
        "The file you are trying to import is missing some of the required data.",
      krViewDefault: true,
      importFileErrorMsg: false,
      timePeriodOptions: false,
      importInitClass: "gbl-btn gbl-btn-slim right buttonUpdate",
      importCancelClass: "gbl-btn gbl-btn-slim gbl-btn-cancel buttonCancelNext",
      importState: 1,
      importButtonText: "update now",
      fileURL: "#"
    };
    this._cancelImport = this._cancelImport.bind(this);
    this._importData = this._importData.bind(this);
    this._resetImport = this._resetImport.bind(this);
    this.handleLastUpdate = this.handleLastUpdate.bind(this);
    this._handleKrReset = this._handleKrReset.bind(this);
    this._onFileChange = this._onFileChange.bind(this);
  }

  _cancelImport() {
    this.setState({ importState: 1 });
    this.setState({
      importInitClass: "gbl-btn gbl-btn-slim right buttonUpdate"
    });
    this.setState({ importButtonText: "update now" });
  }

  _importData() {
    console.log("Importing the data");
    // validate at-least one selection is made

    if (this.state.objectives.length == 0) {
      this.setState({ errorObjective: true });
      return;
    }

    if (this.state.resultMapping.length == 0) {
      this.setState({ errorKR: true });
      return;
    }

    if (this.state.importState == 1) {
      this.setState({ importState: 2 });
      this.setState({ importInitClass: "buttonUpdateNext gbl-btn-slim right" });
      this.setState({ importButtonText: "Yes, update now" });
      return;
    }

    const objectiveMapping = this.state.objectives.slice(-1)[0];
    const monthMapping = this.state.importMonth.slice(-1)[0];
    const yearMapping = this.state.importYear.slice(-1)[0];
    const { resultMapping } = this.state;
    // console.log(this.state.importWeek['week']+"--------this.state.importWeek['week'] %o", this.state.importWeek);
    const weekMapping = this.state.importWeek.week;

    let m = -1;
    let y = -1;
    if (this.state.timePeriodOptions) {
      // if it is timeperiod option
      y = yearMapping.year;
      m = monthMapping.month;
    }
    const mapping = {
      objective: objectiveMapping.objective,
      results: Object.values(resultMapping),
      period: { year: y, month: m, week: weekMapping }
    };

    const period = `${months[monthMapping.month]}, ${yearMapping.year}`;

    const selectedHeaders = [];
    selectedHeaders.push(
      this.state.excelData.headers[objectiveMapping.objective]
    );
    for (const otherCell of mapping.results) {
      selectedHeaders.push(this.state.excelData.headers[otherCell]);
    }

    // console.log("Mappings: %o" ,mapping);
    const excelRows = this.state.excelData.rows;
    const dataToImport = [];
    const krResetMap = this.state.resetKRMapping;
    for (const row of excelRows) {
      const resultArr = [];
      for (const r of resultMapping) {
        let resetTarget = "nil";
        if (krResetMap.has(r)) {
          const obj = krResetMap.get(r);
          resetTarget = row[obj.value];
          resetTarget = { name: obj.name, value: resetTarget };
        }

        resultArr.push({
          kr: this.state.excelData.headers[r],
          value: row[r],
          target: resetTarget
        });
      }
      dataToImport.push({
        goal: row[objectiveMapping.objective],
        krs: resultArr
      });
    }
    let csrf = null;
    if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
      csrf = $.ajaxSetup().data.YII_CSRF_TOKEN;
    }

    const dataToPost = {
      headers: this.state.excelData.headers,
      mapping,
      data: dataToImport,
      YII_CSRF_TOKEN: csrf
    };

    const postDataURL = `${wbConfig.baseUrl}/export/performImport`;
    const _this = this;
    $.post(postDataURL, dataToPost, response => {
      // console.log("post response %o" , response);
      // ToDo first check the status whether it is successful before rendering the table
      ReactDOM.render(
        <ResponseTable
          successRows={response.successRows}
          notSuccessRows={response.notSuccessRows}
          mapping={selectedHeaders}
          fileName={_this.state.fileName}
          fileURL={response.fileURL}
          period={period}
        />,
        document.getElementById("data-management")
      );
    });
  }

  _resetImport() {
    console.log("resetting the state");
    loadDataMgmt();
  }

  handleLastUpdate(event) {
    // Perform objective validation check

    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    // console.log("-- name -- "+name);
    this.setState({ timePeriodOptions: true });
    if (name == "month-update") {
      $(".week-select").hide();

      // hide the week options
      $("#last-update").prop("checked", false);
      $("#week-update").prop("checked", false);
    } else if (name == "week-update") {
      // console.log("Enabling week option");
      setTimeout(() => {
        $(".week-select").show();
      }, 10);

      $("#last-update").prop("checked", false);
      $("#month-update").prop("checked", false);
    } else {
      if (value) {
        this.state.importYear.push({ year: -1 });
        this.state.importMonth.push({ month: -1 });
        this.setState({ timePeriodOptions: false });
      } else {
        this.state.importYear.pop();
        this.state.importMonth.pop();
        this.setState({ timePeriodOptions: true });
      }
      $("#month-update").prop("checked", false);
      $("#week-update").prop("checked", false);
    }
  }

  _handleKrReset(event) {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    console.log("KR reset %o", value);
    if (value) {
      this.setState({
        krViewDefault: false
      });
    } else {
      this.setState({
        krViewDefault: true
      });
    }
  }

  _onFileChange(event) {
    // console.log("On file change");
    this.setState({
      fileName: event.target.value.replace(/C:\\fakepath\\/i, "")
    });

    const formData = [];

    if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
      formData.push({
        name: "YII_CSRF_TOKEN",
        value: $.ajaxSetup().data.YII_CSRF_TOKEN
      });
    }
    formData.push({ name: "UploadForm[file]", value: this.refs.file.files[0] });

    const validateDataURL = `${wbConfig.baseUrl}/export/validateImport`;
    const _this = this;
    const fd = new FormData();

    if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
      fd.append("YII_CSRF_TOKEN", $.ajaxSetup().data.YII_CSRF_TOKEN);
    }
    fd.append("UploadForm[file]", this.refs.file.files[0]);

    $.ajax({
      url: validateDataURL,
      processData: false,
      contentType: false,
      data: fd, // Setting the data attribute of ajax with file_data
      type: "post",
      dataType: "json"
    }).done(response => {
      // console.log("Response %o", response);

      /**
       * Validate file error here
       */
      if (response.status == "success") {
        // hide the help text
        _this.setState({ importCheckList: false });
        _this.setState({ optForOKRs: true, excelData: response });
      } else if (response.status == "error") {
        // first set the error visible
        _this.setState({ importFileErrorMsg: response.errorMsg });
      }
    });
  }

  render() {
    const {t} = this.props;
    const heading = t('Batch update') + " " + t('key results') + " " + t('from a spreadsheet');
    const description =
      t('Update') + " " + t('key results') + " " + t('in one or more objectives from a spreadsheet in three steps; select your file, choose the columns that will be') + " " + t('key result') + " " + t('data and select which column maps to your objectives.');
    const pickerDescription =
      t('1. Select the source file (xls, xlsx, or csv file).');
    const objectiveSelectionHeading =
      t('2. Identify which column maps to objectives');
    const objectiveSelectionDescription =
      t('Select the column that maps to your objectives. The content of the column (each row) must appear in the name of the specific and unique objectives you want to batch update in Workboard.');
    const resultSelectionHeading =
      t('3. Select columns to import as results or metric updates');
    const resultSelectionDescription =
      t('The names of the columns must match the name of the') + " " + t('key results') + " " + t('in Workboard.');
    const resetTargets =
      t('Do you also want to reset your target for the few results?');
    const timeFrameHeading =
      t('4. Choose the time period and update the results.');
    const timeFrameDescription =
      t('There is not a batch undo option. Please check the column mapping carefully. Identify the time period for which you want to post the updates and press "Update Now" to push the results to Workboard.');
    const removeImgUrl = `${wbConfig.baseUrl}/images/Priorities/delete_icon.png`;
    const lastUpdateMSG = t('Update the last data values');
    const monthlyUpdateMSG = t('Update data values for monthly KRs');
    const weeklyUpdateMSG = t('Update data values for weekly KRs');
    return (
      <div className="import-container goalpageRender">
        <div className="displayRow">
          <div className="displayRow">
            <div className="import-heading">{heading}</div>
            <div className="import-description">{description}</div>
          </div>
        </div>
        <div className="picker-container">
          <div className="displayCell picker-fix">
            <div className="import-heading">{pickerDescription}</div>
            {this.state.importCheckList ? (
              <div className="import-check-container">
                <div className="import-checklist">
                  {t('Before your import, please verify the following checklist:')}
                </div>
                <div className="import-checklist-item bullet-it">
                  Your headers must start from row 1 and col 1 in the excel
                </div>
                <div className="import-checklist-item bullet-it">
                  If there is an aggregation row (last row), remove that row
                  from the excel before the import
                </div>
                <div className="import-checklist-item bullet-it">
                  If there is a percentage value column, header name must
                  contain '%' or 'pct' or 'percentage'
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="displayCell">
            <div className="import-button gbl-btn gb-btn-slim">
              Browse...
              <input
                id="ytUploadForm_file"
                type="hidden"
                value=""
                name="UploadForm[file]"
              />
              <input
                className="upload data-import-input"
                name="UploadForm[file]"
                id="UploadForm_file"
                type="file"
                value={this.state.fileInput}
                ref="file"
                onChange={this._onFileChange}
              />
            </div>
            {this.state.fileName && (
              <div className="file-pointer">
                {this.state.fileName}
                <img
                  src={removeImgUrl}
                  className="remove-import-file clickable"
                  width="15"
                  height="15"
                  onClick={this._resetImport}
                />
              </div>
            )}
          </div>
        </div>
        {this.state.importFileErrorMsg && (
          <div className="import-file-error">
            {this.state.importFileErrorMsg}
          </div>
        )}

        {this.state.optForOKRs && (
          <div className="options-container">
            <div className="displayRow">
              <div className="import-heading">{objectiveSelectionHeading}</div>
              <div className="import-description">
                {objectiveSelectionDescription}
              </div>
            </div>
            <ObjectiveSelect
              headers={this.state.excelData.headers}
              objectives={this.state.objectives}
            />
            {this.state.errorObjective && (
              <div className="import-error">
                {this.state.errorObjectiveValue}
              </div>
            )}
            <div className="kr-mapping-container">
              <div className="displayRow">
                <div className="import-heading">{resultSelectionHeading}</div>
                <div className="import-description">
                  {resultSelectionDescription}
                </div>
                <div className="import-description">
                  {resetTargets}
                  <div
                    className="chkbox wbcheckboxcomp in-line-display"
                    style={{ marginLeft: "21px" }}
                  >
                    <input
                      type="checkbox"
                      className="css-checkbox import-inputs"
                      name="kr-reset"
                      id="kr-reset"
                      value="kr-reset"
                      onChange={this._handleKrReset}
                    />
                    <label
                      className="css-label modalParaText"
                      htmlFor="kr-reset"
                    />
                  </div>
                </div>
              </div>
              <div className="displayRow kr-mapping">
                {this.state.krViewDefault ? (
                  <div className="displayRow">
                    <div className="displayCell kr-column bold">Columns</div>
                    <div className="displayCell bold">{t('Key Result')} Match</div>
                  </div>
                ) : (
                  <div className="displayRow">
                    <div className="displayCell kr-column bold">Columns</div>
                    <div className="displayCell kr-column bold">
                    {t('Key Result')} Match
                    </div>
                    <div className="displayCell bold">{t('Key Result')} Target</div>
                  </div>
                )}
                {this.state.errorKR && (
                  <div className="import-error">Please select at least one column that maps to a {t('Key Results')} on Workboard.</div>
                )}

                {this.state.krViewDefault &&
                  this.state.excelData.headers.map((header, i) => (
                    <ResultOptions
                      key={i}
                      col={header}
                      index={i}
                      resultMapping={this.state.resultMapping}
                      krView="default"
                      krMap={this.state.excelData.headers}
                    />
                  ))}

                {!this.state.krViewDefault &&
                  this.state.excelData.headers.map((header, i) => (
                    <ResultOptions
                      key={i}
                      col={header}
                      index={i}
                      resultMapping={this.state.resultMapping}
                      resetKRMapping={this.state.resetKRMapping}
                      krView="reset"
                      krMap={this.state.excelData.headers}
                    />
                  ))}
              </div>
              <div className="displayRow">
                <div className="import-heading">{timeFrameHeading}</div>
                <div className="import-description">{timeFrameDescription}</div>
                <div className="last-data-value data-range-selection">
                  <div className="displayRow">
                    <div className="displayCell">
                      <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                        <input
                          type="checkbox"
                          className="css-checkbox import-inputs"
                          name="last-update"
                          id="last-update"
                          value="last-update"
                          checked={!this.state.timePeriodOptions}
                          onChange={this.handleLastUpdate}
                        />
                        <label
                          className="css-label modalParaText"
                          htmlFor="last-update"
                        />
                      </div>
                    </div>
                    <div className="displayCell">{lastUpdateMSG}</div>
                  </div>
                </div>
                <div className="month-data-value data-range-selection">
                  <div className="displayRow">
                    <div className="displayCell">
                      <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                        <input
                          type="checkbox"
                          className="css-checkbox import-inputs"
                          name="month-update"
                          id="month-update"
                          value="month-update"
                          onChange={this.handleLastUpdate}
                        />
                        <label
                          className="css-label modalParaText"
                          htmlFor="month-update"
                        />
                      </div>
                    </div>
                    <div className="displayCell">{monthlyUpdateMSG}</div>
                  </div>
                </div>
                <div className="week-data-value data-range-selection">
                  <div className="displayRow">
                    <div className="displayCell">
                      <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                        <input
                          type="checkbox"
                          className="css-checkbox import-inputs"
                          name="week-update"
                          id="week-update"
                          value="week-update"
                          onChange={this.handleLastUpdate}
                        />
                        <label
                          className="css-label modalParaText"
                          htmlFor="week-update"
                        />
                      </div>
                    </div>
                    <div className="displayCell">{weeklyUpdateMSG}</div>
                  </div>
                </div>
              </div>
              <div className="displayRow">
                {this.state.timePeriodOptions && (
                  <div className="time-period-option">
                    <div className="displayCell in-line-display time-frame-cell">
                      Time frame for updates:
                    </div>
                    <div className="displayCell in-line-display year-cell">
                      Year:{" "}
                      <YearSelect
                        importYear={this.state.importYear}
                        importWeek={this.state.importWeek}
                      />
                    </div>
                    <div className="displayCell in-line-display month-cell">
                      Month:{" "}
                      <MonthSelect
                        importMonth={this.state.importMonth}
                        importWeek={this.state.importWeek}
                      />
                    </div>
                  </div>
                )}
                <div className="displayCell in-line-display update-now-cell">
                  <div
                    className={this.state.importInitClass}
                    rel="modal:close"
                    onClick={this._importData}
                  >
                    {this.state.importButtonText}
                  </div>
                  {this.state.importState == 2 && (
                    <div
                      className={this.state.importCancelClass}
                      rel="modal:close"
                      onClick={this._cancelImport}
                    >
                      Cancel
                    </div>
                  )}
                </div>
              </div>
              {this.state.importState == 2 && (
                <div className="displayRow">
                  <div className="displayCell in-line-display update-now-alert">
                    The import will update all of your results for the selected
                    period. Please double-check your selection before updating.
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

class ResultOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      krResetSelect: ""
    };
    this.handleSelection = this.handleSelection.bind(this);
    this._handleKrResetSelection = this._handleKrResetSelection.bind(this);
  }

  handleSelection(event) {
    // Perform objective validation check
    const _this = this;
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (value) {
      // console.log("Value: "+value + "name "+name + " target %o" , target);
      _this.props.resultMapping.push(name);

      // also enable the corresponding reset target option
      $(`#krSelect_${name}`).removeAttr("disabled");
    } else {
      // check whether this value is added earlier and then remove it from this array
      if (this.props.resultMapping.indexOf(name) != -1) {
        // console.log("removing from the arr");
        _this.props.resultMapping.splice(
          _this.props.resultMapping.indexOf(name),
          1
        );

        // also disable the corresponding reset target option
        $(`#krSelect_${name}`).attr("disabled", "disabled");
        _this.props.resetKRMapping.delete(name);
      }
    }
  }

  _handleKrResetSelection(event) {
    const _this = this;
    // console.log(" selection value %o", event.target);
    const krId = event.target.getAttribute("data-kr");
    const resetId = event.target.value;

    const index = event.nativeEvent.target.selectedIndex;
    const targetName = event.nativeEvent.target[index].text;
    const valueToHave = { name: targetName, value: resetId };
    // console.log("Reset ID  " +resetId + "target name "+ targetName);
    _this.props.resetKRMapping.set(krId, valueToHave);

    // console.log(" Map value %o", _this.props.resetKRMapping);
  }

  render() {
    const { col } = this.props;
    const { index } = this.props;
    const { krView } = this.props;
    const { krMap } = this.props;
    // console.log("KR map %o", krMap);
    return (
      <div>
        {krView == "default"
          ? $.trim(col).length > 0 && (
              <div>
                <div className="displayRow">
                  <div className="displayCell kr-column">{col}</div>
                  <div className="displayCell">
                    <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                      <input
                        type="checkbox"
                        className="css-checkbox import-inputs"
                        name={index}
                        id={`header-${index}`}
                        value={index}
                        onChange={this.handleSelection}
                      />
                      <label
                        className="css-label modalParaText"
                        htmlFor={`header-${index}`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          : $.trim(col).length > 0 && (
              <div>
                <div className="displayRow">
                  <div className="displayCell kr-column">{col}</div>
                  <div className="displayCell kr-column">
                    <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                      <input
                        type="checkbox"
                        className="css-checkbox import-inputs"
                        name={index}
                        id={`header-${index}`}
                        value={index}
                        onChange={this.handleSelection}
                      />
                      <label
                        className="css-label modalParaText"
                        htmlFor={`header-${index}`}
                      />
                    </div>
                  </div>
                  <div className="displayCell">
                    <select
                      className="kr-select import-inputs"
                      id={`krSelect_${index}`}
                      data-kr={index}
                      onChange={this._handleKrResetSelection}
                      disabled
                    >
                      <option value="-1">none</option>
                      {krMap &&
                        krMap.map(
                          (kr, i) =>
                            $.trim(kr).length > 0 && (
                              <option key={i} value={i} name={kr}>
                                {kr}
                              </option>
                            )
                        )}
                    </select>
                  </div>
                </div>
              </div>
            )}
      </div>
    );
  }
}

class ObjectiveSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.bindSelect2 = this.bindSelect2.bind(this);
  }

  bindSelect2() {
    const _this = this;
    $(_this.refs.objectiveSelect).select2({
      placeholder: "Find by header name"
      //   allowClear: true
    });

    $(_this.refs.objectiveSelect).change(function() {
      const changeSelected = $(this);
      // console.log("-----"+changeSelected.val());
      _this.props.objectives.push({ objective: changeSelected.val() });
    });
  }

  render() {
    const { headers } = this.props;
    return (
      <div className="displayRow objective-select-container">
        <select
          className="objective-select import-inputs"
          id="objectives"
          ref="objectiveSelect"
        >
          {headers &&
            headers.map(
              (header, i) =>
                $.trim(header).length && (
                  <option key={i} value={i}>
                    {header}
                  </option>
                )
            )}
        </select>
      </div>
    );
  }
}

class YearSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.bindSelect2 = this.bindSelect2.bind(this);
  }

  bindSelect2() {
    const _this = this;

    // set the default value
    const date = new Date();
    const currentYear = date.getFullYear();
    _this.props.importWeek.y = currentYear;

    $(_this.refs.yearSelect)
      .select2({
        minimumResultsForSearch: Infinity
      })
      .select2("val", currentYear);

    // $(_this.refs['yearSelect']).val(currentYear);
    // $(_this.refs['yearSelect']).trigger('change');

    $(_this.refs.yearSelect).change(function() {
      const changeSelected = $(this);
      // console.log("-----"+changeSelected.val());
      _this.props.importYear.push({ year: changeSelected.val() });
      _this.props.importWeek.y = changeSelected.val();
      $(".month-select").trigger("change");
    });
  }

  render() {
    const years = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022];
    return (
      <div className="displayRow year-select-container ">
        <select
          className="year-select import-inputs"
          id="objectives"
          ref="yearSelect"
        >
          {years &&
            years.map((year, i) => (
              <option key={i} value={year}>
                {year}
              </option>
            ))}
        </select>
      </div>
    );
  }
}

class MonthSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weeks: []
    };
    this.bindSelect2 = this.bindSelect2.bind(this);
    this.updateWeeks = this.updateWeeks.bind(this);
    this._handleWeekSelection = this._handleWeekSelection.bind(this);
  }

  componentWillMount() {
    const _this = this;
    setTimeout(() => {
      _this.updateWeeks();
    }, 10);
  }

  updateWeeks() {
    const _this = this;
    const w = _this.props.importWeek;

    // console.log("VWeeks %o", w);
    const currentMonth = w.m;
    // console.log("Current month "+ currentMonth);
    const currentYear = w.y;
    // console.log("Current year "+ currentYear);
    const currentWeeks = getWeeksInMonth(currentMonth, currentYear);
    // console.log("Current weeks %o", currentWeeks);
    _this.setState({ weeks: currentWeeks });
  }

  _handleWeekSelection(event) {
    const _this = this;
    const importWeek = event.target.value;
    _this.props.importWeek.week = importWeek;
  }

  bindSelect2() {
    const _this = this;

    // set the default value
    const date = new Date();
    const currentMonth = date.getMonth();

    _this.props.importWeek.m = currentMonth;

    $(_this.refs.monthSelect)
      .select2({
        minimumResultsForSearch: Infinity
      })
      .select2("val", currentMonth);

    $(_this.refs.monthSelect).change(function() {
      const changeSelected = $(this);
      // console.log("-----"+changeSelected.val());
      _this.props.importMonth.push({ month: changeSelected.val() });
      _this.props.importWeek.m = changeSelected.val();
      _this.updateWeeks();
    });
  }

  render() {
    // let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    // set the default value

    return (
      <div className="displayRow month-select-container">
        <select
          className="month-select import-inputs"
          id="objectives"
          ref="monthSelect"
        >
          {months &&
            months.map((month, i) => (
              <option key={i} value={i}>
                {month}
              </option>
            ))}
        </select>
        <select
          className="week-select import-inputs"
          onChange={this._handleWeekSelection}
        >
          <option value="-1">Week</option>
          {this.state.weeks &&
            this.state.weeks.map(
              (week, i) =>
                $.trim(week).length > 0 && (
                  <option key={i} value={week.id}>
                    {week.value}
                  </option>
                )
            )}
        </select>
      </div>
    );
  }
}

export default hot(withTranslation()(ImportContainer));
